import { render, staticRenderFns } from "./CardSpecialty.vue?vue&type=template&id=4766b3c7&scoped=true"
import script from "./CardSpecialty.vue?vue&type=script&lang=js"
export * from "./CardSpecialty.vue?vue&type=script&lang=js"
import style0 from "./CardSpecialty.vue?vue&type=style&index=0&id=4766b3c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4766b3c7",
  null
  
)

export default component.exports